import CurrencyValue from '@/features/finances/components/CurrencyValue';
import { t } from 'i18next';
import { FC } from 'react';

type Props = {
	name: string;
	price: number;
	quantity: number;
};

const NewOrderSummaryElement: FC<Props> = ({ name, price, quantity }) => {
	const total = price * quantity;

	return (
		!!total && (
			<div className='flex gap-4 text-sm'>
				<span className='text-popover-800'>{`${quantity}x`}</span>
				<span className='text-popover-800'>{name}</span>
				{total ? (
					<span className='ml-auto text-popover-800'>
						<CurrencyValue value={total} asset='other' />
					</span>
				) : (
					<span className='ml-auto text-success-1000'>
						{t(
							'main.orders.components.create.components.summary.free',
						)}
					</span>
				)}
			</div>
		)
	);
};

export default NewOrderSummaryElement;
